<div class="container wow fadeIn top-buffer">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <b-card title="Banking Details" type="secondary" shadow header-classes="bg-white pb-5"
                    body-classes="px-lg-5 py-lg-5">
                    <b-card-text>
                        <h4>NedBank</h4>
                        Umbai Africa<br />
                        1203263066 <br />
                        Current account<br />
                        Ref : please user your email address<br />
                        <h4>Standard Bank</h4>
                        Umbai Africa<br />
                        10136525030<br />
                        Current Account<br />
                        use email / cell number as reference<br />
                    </b-card-text>
                </b-card>
            </div>
        </div>
    </div>
    <div class="vld-parent">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    </div>
</div>